import { useCallback, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useStableSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const [params, setParams] = useState(() => {
    return Object.fromEntries(searchParams.entries());
  });

  useEffect(() => {
    (() => {
      const newParams = Object.fromEntries(searchParams.entries());
      setParams((prev) => {
        const isSame =
          Object.keys(prev).length === Object.keys(newParams).length &&
          Object.entries(prev).every(([k, v]) => newParams[k] === v);
        return isSame ? prev : newParams;
      });
    })();
  }, [searchParams]);

  const updateParams = useCallback((newValues) => {
    setSearchParams(newValues);
  }, [setSearchParams]);

  const pureSearchParams = useMemo(() => new URLSearchParams(params), [params]);

  return [pureSearchParams, updateParams];
}